module.exports = __webpack_public_path__ + "static/media/castle.09736707.png";